<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <h3>
                    {{ $store.state.analytics.title }} <v-spacer></v-spacer>
                </h3>
                <v-spacer></v-spacer>
                <v-btn dark icon to="/shift-analytics/expenses-or-revenues"
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-col cols="5">
                            <v-row justify="end">
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="search"
                                        label="Search"
                                        dense
                                        style="margin-top: 0px;padding: 10px;"
                                        hide-details
                                        append-outer="mdi-microsoft-excel"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        <v-data-table
                            dense
                            :headers="headers"
                            :items="items"
                            :search="search"
                            height="600px"
                            disable-items-per-page
                            disable-pagination
                            class="elevation-1"
                            hide-default-footer
                            v-if="show == 1"
                        >
                        <template v-slot:item.Revenue="{ item }">
                        <td >
                            $
                            {{
                                    item.Revenue
                                
                            }}
                        </td>
                    </template>
                    <template v-slot:item.OtherRev="{ item }">
                        <td >
                            $
                            {{
                                    item.OtherRev
                                
                            }}
                        </td>
                    </template>
                    <template v-slot:item.Expenses="{ item }">
                        <td >
                            $
                            {{
                                item.Expenses
                                
                            }}
                        </td>
                    </template>
                    <template v-slot:item.OtherExp="{ item }">
                        <td >
                            $
                            {{
                               item.OtherExp
                                
                            }}
                        </td>
                    </template>
                        </v-data-table>

                        <v-container style="height: 400px;" v-else>
                            <v-row
                                class="fill-height"
                                align-content="center"
                                justify="center"
                            >
                                <v-col
                                    class="text-subtitle-1 text-center"
                                    cols="12"
                                >
                                    Getting your files
                                </v-col>
                                <v-col cols="6">
                                    <v-progress-linear
                                        color="primary accent-4"
                                        indeterminate
                                        rounded
                                        height="6"
                                    ></v-progress-linear>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
export default {
    directives: { mask },
    data: function() {
        return {
            items: [],
            headers: [],
            search: '',
            colspan: 0,
            show: 0,
            drillDown: '',
            Revenue: 0,
            OtherRev: 0,
            Expenses: 0,
            OtherExp: 0,
            Net: 0,
            view: true
        };
    },
    mounted() {
        switch (this.$store.state.analytics.title) {
            case 'Revenues by Invoice':
                this.headers = [
                    { text: 'Invoice Id', value: 'InvId', width: '15%' },
                    { text: 'Invoice Date', value: 'InvDate', width: '20%' },
                    { text: 'ShiftDetail', value: 'ShiftDetail' },
                    { text: 'Date', value: 'Date' },
                    { text: 'Amount', value: 'Amount' }
                ];
                this.drillDown = 'shift-analytics/specific';
                this.$store.state.analytics.subTitle =
                    'Shift Analysis - ShiftDetail Specific';
                this.$store.state.analytics.specific =
                    'shift-analytics/spesific/revenues';
                this.view = false;
                break;
        }
        this.getItems();
    },
    methods: {
        getItems: function() {
            this.Revenue = 0;
            this.OtherRev = 0;
            this.Expenses = 0;
            this.OtherExp = 0;
            var parms = {
                StartDate: this.$store.state.analytics.StartTime,
                EndDate: this.$store.state.analytics.EndTime,
                InvId: this.$store.state.analytics.itm.InvId

            };
            console.log(parms);
            axios
                .post(this.$store.state.analytics.specific, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.items = response.data;
                    this.items.forEach(element => {
                        this.Revenue = element.Revenue + this.Revenue;
                        this.OtherRev = element.OtherRev + this.OtherRev;
                        this.Expenses = element.Expenses + this.Expenses;
                        this.OtherExp = element.OtherExp + this.OtherExp;
                        this.Net = element.net + this.Net;
                    });
                    this.show = 1;
                })
                .catch(function(error) {
                    console.log(error);
                    this.show = 1;
                });
        },
        open: function(itm) {
            this.$store.state.analytics.itm = itm;
            this.$store.state.analytics.return = '/shift-analytics-detail';
            this.$router.push(this.drillDown);
        }
    }
};
</script>
<style>
.hover:hover {
    background: #a4a9de;
}
</style>
